import { api } from "../ApiMapper/api"

export const signup = async (name, email, password) => {
  try {
    const response = await api.post("/api/auth/signup", { name, email, password });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const login = async (email, password) => {
  try {
    const response = await api.post("/api/auth/login", { email, password });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
